import React, { useContext, useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { MARTBUILDER_API } from "../../../constants/serverConfig";
import {
  IoIosCheckmarkCircle,
  IoIosWarning,
  IoMdCloseCircle,
} from "react-icons/io";
import {
  BsPatchCheckFill,
  BsThreeDotsVertical,
  BsCalendar3,
} from "react-icons/bs";
import { FiPlus } from "react-icons/fi";
import { FiCheckCircle } from "react-icons/fi";
import "./PublishLineage.css";
import mysql from "../../../assets/images/DatabaseIcons/mysql.svg";
import dreamio from "../../../assets/images/DatabaseIcons/dreamio.svg";
import postgre from "../../../assets/images/DatabaseIcons/postgre.svg";
import azureDataLake from "../../../assets/images/DatabaseIcons/AzureDataLake.webp";
import clickHouse from "../../../assets/images/DatabaseIcons/Clickhouse.svg";
import microsoftSQL from "../../../assets/images/DatabaseIcons/MicrosoftSQL.svg";
import oracle from "../../../assets/images/DatabaseIcons/Oracle.svg";
import redshift from "../../../assets/images/DatabaseIcons/Redshift.svg";
import salesForce from "../../../assets/images/DatabaseIcons/Salesforce.png";
import snowflake from "../../../assets/images/DatabaseIcons/snowflake.svg";
import SFTP from "../../../assets/images/DatabaseIcons/SFTC.png";
import databricks_logo from "../../../assets/images/LineageIcons/Databricks_dark_logo.png";
import apache_spark from "../../../assets/images/LineageIcons/Apache_Spark_icon.svg";
import apache_airflow from "../../../assets/images/LineageIcons/Apache_Airflow.svg";
import dbt_logo from "../../../assets/images/LineageIcons/Data_build_tool_logo.svg";
import { AuthContext } from "../../../AuthContext";
import { useMsal } from "@azure/msal-react";
import { protectedResources } from "../../../msalConfig";
import CommonBreadcrumb from "../../CommonBreadcrumb/CommonBreadcrumb";
import Spinner from "../../../utils/Spinner";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import RadialSeparators from "./RadialSeparators";

const PublishLineage = () => {
  const { dcerror, dctoken, getDatacraftToken } = useContext(AuthContext);
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const request = {
    scopes: protectedResources.datacraft.scopes,
    account: account,
  };

  const navigate = useNavigate();

  const [connLoading, setConnLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);

  const fetchDataSource = async (dctoken) => {
    setConnLoading(true);
    const ourRequest = axios.CancelToken.source();
    try {
      let response = await axios.get(`${MARTBUILDER_API}/datasources/`, {
        headers: {
          // Define your custom headers here
          Authorization: `Bearer ${dctoken}`,
          "Content-Type": "application/json",
        },
        CancelToken: ourRequest.token,
      });
      // response.data.map((item) => {
      //   console.log("Datasources::::", item.createdBy);
      // });
      console.log("Datasources::::", response.data);
      const filteredResult = response.data.filter(
        (item) => item.product?.createdBy === account.username
      );
      setDataSource(response.data);
      setConnLoading(false);
    } catch (err) {
      if (axios.isCancel(err)) {
        return;
      } else {
        console.error(err);
      }
      setConnLoading(false);
    }
    return () => {
      ourRequest.cancel();
    };
  };

  const callapiwithtoken = async (callback) => {
    (async () => await getDatacraftToken())();
    if (dctoken) {
      await callback(dctoken);
    }
    if (dcerror) {
      try {
        const rtoken = (await instance.acquireTokenRedirect(request))
          .accessToken;
        await callback(rtoken);
      } catch (error) {
        console.log(error);
      }
    }
  };

  // useEffect(() => {
  //   callapiwithtoken(fetchDataSource);
  // }, [dctoken, dcerror]);

  return (
    <>
      <CommonBreadcrumb
        href1={"/dataBook/PublishLineage"}
        path1={"Publish Lineage"}
      />
      <div style={{ padding: "1.4rem 2.1rem" }}>
        <div className="pubLinePageHeader">
          <h3>Lineage</h3>
          <button
            className="nar-wid1 job-btn round-btn"
            onClick={() => {
              navigate("/databook/addNewLineage");
            }}
          >
            + Enable New Lineage
          </button>
        </div>
        <div className="pubLinePageContent">
          <div className="pubLineSingleCard">
            <div className="pubLinePageHeader">
              <p className="pubLineTechName">Product Name</p>
              <div className="pubLineImageText">
                <img
                  src={databricks_logo}
                  alt="databricks"
                  className="pubLineTechLogo"
                />
                <FiCheckCircle size={20} style={{ color: "#008000" }} />
                <BsThreeDotsVertical size={14} />
              </div>
            </div>
            <div style={{ marginBottom: "14px" }}>
              <p className="pubLineName">ADB Name 1</p>
              <p className="pubLineTimeDetails">Created a day ago</p>
            </div>
            <div>
              <p
                style={{
                  fontSize: "12px",
                  color: "#000000",
                  wordWrap: "break-word",
                }}
              >
                https://adb-sjdfhkdfg6sdg6emantic-apmt-dev.maersk-digital.net/#/schema
              </p>

              <div
                style={{ height: "6rem", width: "6rem", margin: "1rem auto" }}
              >
                <CircularProgressbarWithChildren
                  value={75}
                  text={`${75}%`}
                  strokeWidth={10}
                  styles={buildStyles({
                    strokeLinecap: "butt",
                    textSize: "18px",
                    textColor: "#000000",
                    pathColor: "#10a9b7",
                  })}
                  counterClockwise={true}
                >
                  <RadialSeparators
                    count={12}
                    style={{
                      background: "#fff",
                      width: "2px",
                      // This needs to be equal to props.strokeWidth
                      height: `${10}%`,
                    }}
                  />
                </CircularProgressbarWithChildren>
              </div>
            </div>
            <div className="pubLineActionContainer">
              <div className="pubLineActionBox">
                {/* <IoIosCheckmarkCircle size={24} fill="green" /> */}
                <p style={{ fontSize: "12px", color: "#888888" }}>Start Date</p>
                <p>9 May 2024</p>
              </div>
              <div className="pubLineActionBox">
                {/* <p className="pubLineCrawlTrue">3</p>
                <p>Data Crawl</p> */}
                <p style={{ fontSize: "12px", color: "#888888" }}>End Date</p>
                <p>11 May 2024</p>
              </div>
            </div>
          </div>
          <div className="pubLineSingleCard">
            <div className="pubLinePageHeader">
              <p className="pubLineTechName">Product Name</p>
              <div className="pubLineImageText">
                <img
                  src={apache_spark}
                  alt="apache_spark"
                  className="pubLineTechLogo"
                />
                <FiCheckCircle size={20} style={{ color: "#008000" }} />
                <BsThreeDotsVertical size={14} />
              </div>
            </div>
            <div style={{ marginBottom: "14px" }}>
              <p className="pubLineName">msk.databookprodlineage...</p>
              <p className="pubLineTimeDetails">Created 2 days ago</p>
            </div>
            <div>
              <p
                style={{
                  fontSize: "12px",
                  color: "#000000",
                  wordWrap: "break-word",
                }}
              >
                Topic:msk.databookopenlineageprod.lns.topic.internal.any.v1
              </p>
              <div
                style={{ height: "6rem", width: "6rem", margin: "1rem auto" }}
              >
                <CircularProgressbarWithChildren
                  value={75}
                  text={`${75}%`}
                  strokeWidth={10}
                  styles={buildStyles({
                    strokeLinecap: "butt",
                    textSize: "18px",
                    textColor: "#000000",
                    pathColor: "#10a9b7",
                    // pathColor:"linear-gradient(#10a9b7, #38cbca)"
                  })}
                  counterClockwise={true}
                >
                  <RadialSeparators
                    count={12}
                    style={{
                      background: "#fff",
                      width: "2px",
                      // This needs to be equal to props.strokeWidth
                      height: `${10}%`,
                    }}
                  />
                </CircularProgressbarWithChildren>
              </div>
            </div>
            <div className="pubLineActionContainer">
              <div className="pubLineActionBox">
                {/* <IoIosCheckmarkCircle size={24} fill="green" /> */}
                <p style={{ fontSize: "12px", color: "#888888" }}>Start Date</p>
                <p>9 May 2024</p>
              </div>
              <div className="pubLineActionBox">
                {/* <p className="pubLineCrawlFalse">5</p>
                <p>Data Crawl</p> */}
                <p style={{ fontSize: "12px", color: "#888888" }}>End Date</p>
                <p>11 May 2024</p>
              </div>
            </div>
          </div>
          <div className="pubLineSingleCard">
            <div className="pubLinePageHeader">
              <p className="pubLineTechName">Product Name</p>
              <div className="pubLineImageText">
                <img src={apache_airflow} alt="apache_airflow" className="pubLineTechLogo" />
                <BsCalendar3 size={20} fill="#000000" />
                <BsThreeDotsVertical size={14} />
              </div>
            </div>
            <div style={{ marginBottom: "14px" }}>
              <p className="pubLineName">msk.databookprodlineage...</p>
              <p className="pubLineTimeDetails">Created 5 days ago</p>
            </div>
            <div>
              <p
                style={{
                  fontSize: "12px",
                  color: "#000000",
                  wordWrap: "break-word",
                }}
              >
                Topic:msk.databookopenlineageprod.lns.topic.internal.any.v1
              </p>
            </div>
            <div
              className="pubLineActionContainer"
              style={{ flexDirection: "column", gap: "1rem" }}
            >
              <div
                className="pubLineActionBox"
                style={{ alignItems: "flex-start" }}
              >
                {/* <IoIosCheckmarkCircle size={24} fill="green" /> */}
                <p style={{ fontSize: "12px", color: "#888888" }}>Start Date</p>
                <p>13 May 2024</p>
              </div>
              <div
                className="pubLineActionBox"
                style={{ alignItems: "flex-start" }}
              >
                {/* <p className="pubLineCrawlTrue">3</p>
                <p>Data Crawl</p> */}
                <p style={{ fontSize: "12px", color: "#888888" }}>End Date</p>
                <p>14 May 2024</p>
              </div>
            </div>
          </div>
          <div className="pubLineSingleCard">
            <div className="pubLinePageHeader">
              <p className="pubLineTechName">Product Name</p>
              <div className="pubLineImageText">
                <img src={apache_spark} alt="apache_spark" className="pubLineTechLogo" />
                <IoIosWarning size={20} fill="orange" />
                <BsThreeDotsVertical size={14} />
              </div>
            </div>
            <div style={{ marginBottom: "14px" }}>
              <p className="pubLineName">ADB Name 4</p>
              <p className="pubLineTimeDetails">Updated 1 month ago</p>
            </div>
            <div>
              <p
                style={{
                  fontSize: "12px",
                  color: "#000000",
                  wordWrap: "break-word",
                }}
              >
                https://adb-sjdfhkdfg6sdg6emantic-apmt-dev.maersk-digital.net/#/schema
              </p>
            </div>
            <div className="pubLineActionContainerError">
              {/* <div className="pubLineActionBox">
                <IoIosCheckmarkCircle size={24} fill="green" />
                <p style={{ fontSize: "12px" }}>Connection</p>
              </div>
              <div className="pubLineActionBox">
                <p className="pubLineCrawlTrue">+</p>
                <p>Data Crawl</p>
              </div> */}
              <span style={{ color: "#FA8072" }}>Kafka Broker Error</span>
              <p style={{ fontSize: "12px" }}>
                Your existing token doesn't authorize you anymore. Please update
                your credentials.
              </p>
            </div>
          </div>
          <div className="pubLineSingleCard">
            <div className="pubLinePageHeader">
              <p className="pubLineTechName">Product Name</p>
              <div className="pubLineImageText">
                <img src={databricks_logo} alt="databricks_logo" className="pubLineTechLogo" />
                <IoIosWarning size={20} fill="orange" />
                <BsThreeDotsVertical size={14} />
              </div>
            </div>
            <div style={{ marginBottom: "14px" }}>
              <p className="pubLineName">ADB Name 5</p>
              <p className="pubLineTimeDetails">Updated 2 months ago</p>
            </div>
            <div>
              <p
                style={{
                  fontSize: "12px",
                  color: "#000000",
                  wordWrap: "break-word",
                }}
              >
                https://adb-sjdfhkdfg6sdg6emantic-apmt-dev.maersk-digital.net/#/schema
              </p>
            </div>
            <div className="pubLineActionContainerError">
              {/* <div className="pubLineActionBox">
                <IoIosCheckmarkCircle size={24} fill="green" />
                <p style={{ fontSize: "12px" }}>Connection</p>
              </div>
              <div className="pubLineActionBox">
                <p className="pubLineCrawlFalse">4</p>
                <p>Data Crawl</p>
              </div> */}
              <span style={{ color: "#FA8072" }}>Token Invalid</span>
              <p style={{ fontSize: "12px" }}>
                Your existing token doesn't authorize you anymore. Please update
                your credentials.
              </p>
            </div>
          </div>
          <div className="pubLineSingleCard">
            <div className="pubLinePageHeader">
              <p className="pubLineTechName">Product Name</p>
              <div className="pubLineImageText">
                <img src={databricks_logo} alt="databricks_logo" className="pubLineTechLogo" />
                <BsPatchCheckFill size={20} fill="#007fff" />
                <BsThreeDotsVertical size={14} />
              </div>
            </div>
            <div style={{ marginBottom: "14px" }}>
              <p className="pubLineName">ADB Name 6</p>
              <p className="pubLineTimeDetails">Created 7 months ago</p>
            </div>
            <div>
              <p
                style={{
                  fontSize: "12px",
                  color: "#000000",
                  wordWrap: "break-word",
                }}
              >
                https://adb-sjdfhkdfg6sdg6emantic-apmt-dev.maersk-digital.net/#/schema
              </p>
            </div>
            <div className="pubLineActionContainerSuccess">
              {/* <div className="pubLineActionBox">
                <IoIosCheckmarkCircle size={24} fill="green" />
                <p style={{ fontSize: "12px" }}>Connection</p>
              </div>
              <div className="pubLineActionBox">
                <p className="pubLineCrawlFalse">1</p>
                <p>Data Crawl</p>
              </div> */}
              <span style={{ color: "#008000" }}>Lineage Enabled</span>
            </div>
            <div style={{ margin: "0.8rem" }}>
              <p
                style={{
                  fontSize: "12px",
                  color: "#000000",
                  wordWrap: "break-word",
                }}
              >
                Metadata about ADB Access, datasets accessed, other status.
              </p>
            </div>
          </div>
          <div className="pubLineSingleCard">
            <div className="pubLinePageHeader">
              <p className="pubLineTechName">Product Name</p>
              <div className="pubLineImageText">
                <img src={databricks_logo} alt="databricks_logo" className="pubLineTechLogo" />
                <BsPatchCheckFill size={20} fill="#007fff" />
                <BsThreeDotsVertical size={14} />
              </div>
            </div>
            <div style={{ marginBottom: "14px" }}>
              <p className="pubLineName">ADB Name 7</p>
              <p className="pubLineTimeDetails">Updated 8 months ago</p>
            </div>
            <div>
              <p
                style={{
                  fontSize: "12px",
                  color: "#000000",
                  wordWrap: "break-word",
                }}
              >
                https://adb-sjdfhkdfg6sdg6emantic-apmt-dev.maersk-digital.net/#/schema
              </p>
            </div>
            <div className="pubLineActionContainerSuccess">
              {/* <div className="pubLineActionBox">
                <IoIosCheckmarkCircle size={24} fill="green" />
                <p style={{ fontSize: "12px" }}>Connection</p>
              </div>
              <div className="pubLineActionBox">
                <p className="pubLineCrawlTrue">1</p>
                <p>Data Crawl</p>
              </div> */}
              <span style={{ color: "#008000" }}>Lineage Enabled</span>
            </div>
            <div style={{ margin: "0.8rem" }}>
              <p
                style={{
                  fontSize: "12px",
                  color: "#000000",
                  wordWrap: "break-word",
                }}
              >
                Metadata about ADB Access, datasets accessed, other status.
              </p>
            </div>
          </div>
          <div className="pubLineSingleCard">
            <div className="pubLinePageHeader">
              <p className="pubLineTechName">Product Name</p>
              <div className="pubLineImageText">
                <img src={dbt_logo} alt="dbt_logo" className="pubLineTechLogo" />
                <BsPatchCheckFill size={20} fill="#007fff" />
                <BsThreeDotsVertical size={14} />
              </div>
            </div>
            <div style={{ marginBottom: "14px" }}>
              <p className="pubLineName">msk.databookprodlineage...</p>
              <p className="pubLineTimeDetails">Updated 9 months ago</p>
            </div>
            <div>
              <p
                style={{
                  fontSize: "12px",
                  color: "#000000",
                  wordWrap: "break-word",
                }}
              >
                Topic:msk.databookopenlineageprod.lns.topic.internal.any.v1
              </p>
            </div>
            <div className="pubLineActionContainerSuccess">
              {/* <div className="pubLineActionBox">
                <IoIosCheckmarkCircle size={24} fill="green" />
                <p style={{ fontSize: "12px" }}>Connection</p>
              </div>
              <div className="pubLineActionBox">
                <p className="pubLineCrawlNull"> </p>
                <p>Data Crawl</p>
              </div> */}
              <span style={{ color: "#008000" }}>Lineage Enabled</span>
            </div>
            <div style={{ margin: "0.8rem" }}>
              <p
                style={{
                  fontSize: "12px",
                  color: "#000000",
                  wordWrap: "break-word",
                }}
              >
                Metadata about ADB Access, datasets accessed, other status.
              </p>
            </div>
          </div>
        </div>
        {/* {connLoading ? (
          <div className="justify-content-md-center">
            <Spinner />
          </div>
        ) : (
          <>
            {dataSource.length === 0 && (
              <div className="no-match">
                <h4>There are no Connections yet!</h4>
                <div style={{ margin: "0 8px" }}>
                  <h4>
                    Please click{" "}
                    <Link to="/databook/createDataSources">here</Link> to create
                    a new connection.
                  </h4>
                </div>
              </div>
            )}
            <div className="pubLinePageContent">
              {dataSource?.map((data) => (
                <>
                  <NavLink to="/databook/connectiondetail">
                    <div className="pubLineSingleCard">
                      <div className="pubLinePageHeader">
                        <p className="pubLineTechName">{data.product.name}</p>
                        <div className="pubLineImageText">
                          {data.datasourceType === "Dremio" && (
                            <img
                              src={dreamio}
                              alt="dremio"
                              className="pubLineTechLogo"
                            />
                          )}
                          {data.datasourceType === "MicrosoftSQL" && (
                            <img
                              src={microsoftSQL}
                              alt="microsoftSQL"
                              className="pubLineTechLogo"
                            />
                          )}
                          {data.datasourceType === "AzureDataLake" && (
                            <img
                              src={azureDataLake}
                              alt="azureDataLake"
                              className="pubLineTechLogo"
                            />
                          )}
                          {data.datasourceType === "MySQL" && (
                            <img src={mysql} alt="mysql" className="pubLineTechLogo" />
                          )}
                          {data.datasourceType === "PostgreSQL" && (
                            <img
                              src={postgre}
                              alt="postgre"
                              className="pubLineTechLogo"
                            />
                          )}
                          {data.datasourceType === "SFTP" && (
                            <img src={SFTP} alt="SFTP" className="pubLineTechLogo" />
                          )}
                          {data.datasourceType === "ClickHouse" && (
                            <img
                              src={clickHouse}
                              alt="clickHouse"
                              className="pubLineTechLogo"
                            />
                          )}
                          {data.datasourceType === "Oracle" && (
                            <img
                              src={oracle}
                              alt="oracle"
                              className="pubLineTechLogo"
                            />
                          )}
                          {data.datasourceType === "SalesForce" && (
                            <img
                              src={salesForce}
                              alt="salesForce"
                              className="pubLineTechLogo"
                            />
                          )}
                          {data.datasourceType === "Redshift" && (
                            <img
                              src={redshift}
                              alt="redshift"
                              className="pubLineTechLogo"
                            />
                          )}
                          {data.datasourceType === "Snowflake" && (
                            <img
                              src={snowflake}
                              alt="snowflake"
                              className="pubLineTechLogo"
                            />
                          )}
                          <BsPatchCheckFill size={20} fill="#007fff" />
                          <BsThreeDotsVertical size={14} />
                        </div>
                      </div>
                      <div style={{ marginBottom: "14px" }}>
                        <p className="pubLineName">{data.connectionName}</p>
                        <p className="pubLineTimeDetails">
                          Created at: {data.product?.createdAt?.slice(0, 10)}
                        </p>
                        <p className="pubLineTimeDetails">
                          Created by: {data.product?.createdBy}
                        </p>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#000000",
                            padding: "0.2rem",
                          }}
                        >
                          <span>Business Name: </span>
                          {data.product.business.name}
                        </p>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#000000",
                            padding: "0.2rem",
                          }}
                        >
                          <span>Domain Name: </span>
                          {data.product.domain.name}
                        </p>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#000000",
                            padding: "0.2rem",
                          }}
                        >
                          <span>Orgmodel Name: </span>
                          {data.product.orgModel.name}
                        </p>
                      </div>
                      <div className="pubLineActionContainer">
                        <div
                          className="pubLineActionBox"
                          style={{ opacity: "0.6", cursor: "not-allowed" }}
                        >
                          <p className="pubLineCrawlTrue">0</p>
                          <p>Data Crawl</p>
                        </div>
                      </div>
                    </div>
                  </NavLink>
                </>
              ))}
            </div>
          </>
        )} */}
      </div>
    </>
  );
};

export default PublishLineage;
